import { MutationTree } from "vuex";
import { CompanyState } from "./types";

export const mutations: MutationTree<CompanyState> = {
    // 保存用户信息
    set(state, value: CompanyState) {
        state = Object.assign(state, value)
    },
};
